import styled from "styled-components"

export const AuditLogsScreenWrapper = styled.div`
  [class^="Tablestyles__TableData"] {
    overflow: visible;
  }
`
